import React from "react";
import "./payment-status.scss";

const statusColors: { [key: string]: string } = {
    "Pending": "status-pending",
    "Paid": "status-approved",
    "Completed": "status-approved",
    "Succeeded": "status-approved",
    "Confirmed": "status-approved",
    "Cancelled": "status-rejected",
    "Failed": "status-rejected",
    "Refunded": "status-completed",
    "Primary": "status-primary",
    "Secondary": "status-secondary",
    "Not Initiated": "status-not-initiated"
};

const PaymentStatus: React.FC<{ status: string }> = ({ status }) => {
    return (
        <span
            className={`status-badge  ${statusColors[status]} table-cell-ellipsis`}
        >
            {status}
        </span>
    );
};

export default PaymentStatus;

